import type { SVGProps } from "react";
export interface Copy02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Copy02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Copy02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.798 13.087a1.125 1.125 0 0 1 1.391.579l.044.107.084.198c.187.384.5.699.885.886l.197.082.107.044a1.125 1.125 0 0 1-.745 2.11l-.112-.033-.218-.083a4.17 4.17 0 0 1-2.234-2.234l-.085-.22-.033-.11a1.126 1.126 0 0 1 .719-1.326M.875 10.1V8.075a1.125 1.125 0 0 1 2.25 0v2.024a1.125 1.125 0 0 1-2.25 0Zm2.774-8.987a1.125 1.125 0 0 1 .75 2.121A1.92 1.92 0 0 0 3.233 4.4a1.125 1.125 0 1 1-2.12-.75 4.17 4.17 0 0 1 2.536-2.537m9.438.686c.195-.55.772-.854 1.326-.72l.11.034.22.085a4.17 4.17 0 0 1 2.234 2.234l.083.218.034.112a1.125 1.125 0 0 1-2.111.745l-.044-.107-.082-.197a1.92 1.92 0 0 0-.886-.885l-.198-.084-.107-.044a1.125 1.125 0 0 1-.579-1.391M10.1.875l.114.006a1.125 1.125 0 0 1 0 2.238l-.114.006H8.075a1.125 1.125 0 0 1 0-2.25zM20.875 11c0-1.036-.84-1.875-1.875-1.875h-8c-1.036 0-1.875.84-1.875 1.875v8c0 1.035.84 1.875 1.875 1.875h8c1.035 0 1.875-.84 1.875-1.875zm2.25 8A4.125 4.125 0 0 1 19 23.125h-8A4.125 4.125 0 0 1 6.875 19v-8A4.125 4.125 0 0 1 11 6.875h8A4.125 4.125 0 0 1 23.125 11z"
      />
    </svg>
  );
}
